import { render, staticRenderFns } from "./ReminderPlansDetailsDataComponet.vue?vue&type=template&id=6f829e90&"
import script from "./ReminderPlansDetailsDataComponet.vue?vue&type=script&lang=js&"
export * from "./ReminderPlansDetailsDataComponet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports